import { useCallback, useEffect, useRef } from "react";
import { Base } from '../template'
import { useApp } from '_hooks';
import logo from '_utilities/images/logo.png';
import { Link } from "react-router-dom";

const prefix = "v-privacy";

const Privacy = () => {
  const initialized = useRef(null);
  const { fetchPrivacy, privacy } = useApp();

  const init = useCallback(() => {
    if (!privacy && !initialized?.current) {
      initialized.current = true;
      fetchPrivacy();
    }
  }, [fetchPrivacy, privacy]);
  
  useEffect(() => {
    init();
  }, [init]);

  return (
    <Base
      align="start"
      headerClass="flex-1"
    >
      <div className={`${prefix} container flex flex-wrap flex-col py-3 px-8 mx-auto`}>
        <div className="flex flex-wrap flex-col gap-7">
          <Link to="/" ><img src={logo} alt="logo" className="w-[55%] mx-auto mb-5 max-w-[350px] min-w-[100px]" /></Link>
          <p className="text-3xl font-bold text-center mx-auto">Aviso de privacidad</p>
          <div className="text-justify" 
            dangerouslySetInnerHTML={
              { __html: privacy?.text }
            }
          ></div>
        </div>
      </div>
    </Base>
  );
};

export default Privacy;
